import { useContext, useEffect } from "react";
import {
  deleteTransaction,
  updateTransaction,
  createTransaction,
  getAdminTransactions
} from "../../../api/transaction";
import BootstrapTable from "./CommanPage";
const Transactions = () => {
  const TRANSACTION_FIELD = [
    // {
    //   name: "email",
    //   label: "Email",
    //   type: "email",
    //   placeholder: "Enter your email",
    //   isForm: true,
    //   isTable: true,
    //   validation: {
    //     required: "Email is required",
    //     pattern: {
    //       value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
    //       message: "Invalid email addres s",
    //     },
    //   },
    // },
    {
      name: "type",
      label: "Transaction Type",
      type: "select",
      placeholder: "Select transaction type",
      isForm: true,
      isTable: true,
      options: [
        { label: "Buy", value: "buy" },
        { label: "Sell", value: "sell" },
      ],
      validation: {
        required: "Transaction type is required",
      },
    },
    // {
    //   name: "symbol",
    //   label: "Symbol",
    //   type: "text",
    //   placeholder: "Enter Your Symbol",
    //   isForm: true,
    //   isTable: true,
    //   //   options: [
    //   //     { value: "admin", label: "Admin" },
    //   //     { value: "user", label: "User" },
    //   //   ],
    //   validation: {
    //     required: "Transaction Symbol is required",
    //   },
    // },
    {
      name: "tokenId",
      label: "TokernId",
      type: "text",
      placeholder: "Enter Your tokenId",
      isForm: true,
      isTable: true,
      //   options: [
      //     { value: "admin", label: "Admin" },
      //     { value: "user", label: "User" },
      //   ],
      validation: {
        required: "TokenId is required",
      },
    },
    {
      name: "amount",
      label: "Amount",
      type: "number",
      placeholder: "Enter Your Amount",
      isForm: true,
      isTable: true,
      //   options: [
      //     { value: "admin", label: "Admin" },
      //     { value: "user", label: "User" },
      //   ],
      validation: {
        required: "Amount is required",
      },
    },
    {
      name: "pricePerToken",
      label: "Price Per Token",
      type: "number",
      placeholder: "Enter Your price per token",
      isForm: true,
      isTable: true,
      //   options: [
      //     { value: "admin", label: "Admin" },
      //     { value: "user", label: "User" },
      //   ],
      validation: {
        required: "Price Per Required is required",
      },
    },

    // {
    //   name: "isActive",
    //   label: "Active",
    //   type: "checkbox",
    //   isForm: true,
    //   isTable: true,
    //   render: (val) => (val ? "✅ Active" : "❌ Inactive"),
    // },
    {
      name: "createdAt",
      label: "Created At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
    {
      name: "updatedAt",
      label: "Updated At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
  ];

  
  return (
    <BootstrapTable
      fields={TRANSACTION_FIELD}
      title={"Transactions"}
      getAllRecord={getAdminTransactions}
      deleteRecord={deleteTransaction}
      updateRecord={updateTransaction}
      createRecord={createTransaction}
    />
  );
};

export default Transactions;
